import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgSprayBottle = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M19.1875 3.875L20.75 2.9375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.1875 8.25L20.75 9.1875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.1875 6.0625H21.0625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1875 3.5625H8.5625C7.56794 3.5625 6.61411 3.95759 5.91085 4.66085C5.20759 5.36411 4.8125 6.31794 4.8125 7.3125H7.9375V11.0625H10.4375V7.3125H14.1875V3.5625Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.4375 7.3125C10.4375 7.3125 12.3125 10.4375 14.8125 10.4375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.6875 13.5625V12.3125C11.6875 11.981 11.5558 11.663 11.3214 11.4286C11.087 11.1942 10.769 11.0625 10.4375 11.0625H7.9375C7.60598 11.0625 7.28804 11.1942 7.05362 11.4286C6.8192 11.663 6.6875 11.981 6.6875 12.3125V13.5625C4.8125 13.5625 2.9375 14.8125 2.9375 18.5625C2.9375 19.2255 3.20089 19.8614 3.66973 20.3303C4.13857 20.7991 4.77446 21.0625 5.4375 21.0625H12.9375C13.6005 21.0625 14.2364 20.7991 14.7053 20.3303C15.1741 19.8614 15.4375 19.2255 15.4375 18.5625C15.4375 14.8125 13.5625 13.5625 11.6875 13.5625Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6875 4.8125V6.6875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgSprayBottle.displayName = 'SvgSprayBottle';
export default SvgSprayBottle;
